import { render, staticRenderFns } from "./SubjectSituation.vue?vue&type=template&id=72d798f8&scoped=true&lang=pug&"
import script from "./SubjectSituation.vue?vue&type=script&lang=ts&"
export * from "./SubjectSituation.vue?vue&type=script&lang=ts&"
import style0 from "./SubjectSituation.vue?vue&type=style&index=0&id=72d798f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d798f8",
  null
  
)

export default component.exports